import { render } from "./Directorates.vue?vue&type=template&id=e4476288"
import script from "./Directorates.vue?vue&type=script&lang=js"
export * from "./Directorates.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__